import { io } from 'socket.io-client';

export const socket = (urlApi: string) => io(urlApi);
